import { getDefaultConfiguration } from '@nv/contexts'

const getConfigurations = ({ t }) => {
  const defaultConfiguration = getDefaultConfiguration(t)
  return {
    ...defaultConfiguration,
    languages: {
      en: 'English',
      fr: 'Francais',
    },
    votingMethodOptions: [
      { label: t('admin.electorsList.votedChannelOptions.online'), value: 'online' },

      // { label: t('admin.electorsList.votedChannelOptions.inPerson'), value: 'inPerson' },
    ],
    electionDate: new Date(),
    // registrationOpensDate: '2025-09-08T12:00:00', //TODO uncomment after testing
    minAge: 18,
    registrationPhoneRequired: true,
    includeSingleNameField: false,
    maxSessionTimeMinsAdmin: 4 * 60,
    maxSessionTimeMinsVoter: 30,
    votingDistrictOptions: [],
    knownIdNumberTextFieldConfig: { type: 'number', maxChars: 6 },
    enableManualEntryAddress: false,
    enableSingleFieldMailingAddress: false,
    enableDifferentMailingAddress: false,
    mailingAddressRequiredVoteByMail: true,
    displayStrikeOffOnlyVotingChannels: ['inPerson', 'online'], //TODO add voting channels
    reverseStrikeOffEnabled: false,
    includeWebAuthnLoginAdmin: false,
    includeLoginButtonRegistrationPage: false,
    includeRegisterButtonRegistrationPage: false,
    confirmEligibilityToVote: true,
    showCurrentTime: false,
    hideSessionTimers: {
      admin: false,
      voter: true,
    },
    showLogoutModal: true,
    showVoterInactivityModal: true,
    voterInactivityWarningMins: 14,
    voterAuth: {
      pinLogin: true,
    },
    surveyLink: 'https://www.google.com', // TODO config var survey link
    emsLink: 'https://election-client.staging-5.assemblyvoting.net', // TODO config var
  }
}
export default getConfigurations
